"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const eventemitter3_1 = require("eventemitter3");
const constants_1 = require("../constants");
const directionsMap = {
    [constants_1.ORIENTATIONS.HORIZONTAL]: {
        [constants_1.ANCHOR_POINTS.TOP_LEFT]: constants_1.DIRECTIONS.STANDARD,
        [constants_1.ANCHOR_POINTS.TOP_RIGHT]: constants_1.DIRECTIONS.REVERSE,
        [constants_1.ANCHOR_POINTS.BOTTOM_LEFT]: constants_1.DIRECTIONS.STANDARD,
        [constants_1.ANCHOR_POINTS.BOTTOM_RIGHT]: constants_1.DIRECTIONS.REVERSE,
    },
    [constants_1.ORIENTATIONS.VERTICAL]: {
        [constants_1.ANCHOR_POINTS.TOP_LEFT]: constants_1.DIRECTIONS.STANDARD,
        [constants_1.ANCHOR_POINTS.TOP_RIGHT]: constants_1.DIRECTIONS.STANDARD,
        [constants_1.ANCHOR_POINTS.BOTTOM_LEFT]: constants_1.DIRECTIONS.REVERSE,
        [constants_1.ANCHOR_POINTS.BOTTOM_RIGHT]: constants_1.DIRECTIONS.REVERSE,
    },
};
class CardsConfig extends eventemitter3_1.EventEmitter {
    constructor() {
        super();
        this._orientation = constants_1.ORIENTATIONS.HORIZONTAL;
        this._anchorPoint = constants_1.ANCHOR_POINTS.BOTTOM_LEFT;
        this._isPreviewMode = false;
    }
    get orientation() {
        return this._orientation;
    }
    set orientation(value) {
        this._orientation = value;
        this.emit(constants_1.EVENTS.CONFIG_CHANGED);
    }
    get anchorPoint() {
        return this._anchorPoint;
    }
    set anchorPoint(value) {
        this._anchorPoint = value;
        this.emit(constants_1.EVENTS.CONFIG_CHANGED);
    }
    get isPreviewMode() {
        return this._isPreviewMode;
    }
    set isPreviewMode(value) {
        this._isPreviewMode = value;
        this.emit(constants_1.EVENTS.CONFIG_CHANGED);
    }
    get direction() {
        const { anchorPoint, orientation } = this;
        return directionsMap[orientation][anchorPoint];
    }
    onChange(callback, context) {
        this.on(constants_1.EVENTS.CONFIG_CHANGED, callback, context);
    }
    destroy() {
        this.eventNames().forEach((eventName) => {
            this.removeAllListeners(eventName);
        });
    }
}
exports.default = CardsConfig;
//# sourceMappingURL=cards-config.js.map